"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.InvalidCodeException = void 0;
const error_interface_1 = require("@sigmasms/shared-types/exceptions/error.interface");
const common_exception_1 = require("../../../common.exception");
/**
 * Код, введенный пользователем, неправильный
 */
let InvalidCodeException = class InvalidCodeException extends common_exception_1.CommonException {
    constructor(input = {}) {
        var _a;
        input.type = 'InvalidCodeException';
        input.message = (_a = input.message) !== null && _a !== void 0 ? _a : 'Код, введенный пользователем, неправильный';
        input.transportPayload = { httpStatus: error_interface_1.HttpStatus.BAD_REQUEST };
        super(input);
    }
};
exports.InvalidCodeException = InvalidCodeException;
exports.InvalidCodeException = InvalidCodeException = __decorate([
    (0, common_exception_1.RegisterException)(),
    __metadata("design:paramtypes", [Object])
], InvalidCodeException);
//# sourceMappingURL=invalid-code.exception.js.map